import classNames from 'classnames';
import { Icon } from '@/components';
import { useSelectLang } from '@/hooks';

const SelectLang = () => {
  const { lang, changeLang } = useSelectLang();
  const path = window.location.pathname;
  const isLogin = path.includes('login');

  return (
    <span
      className={classNames(
        `font-medium text-[14px] cursor-pointer h-[100%] relative
          flex items-center justify-center gap-x-[6px] pr-[32px]`,
        isLogin ? 'text-[#ffffff]' : 'text-[#111111]',
      )}
      onClick={changeLang}
    >
      <span>{lang}</span>
      {isLogin && (
        <Icon
          type="icon-icon_sanjiaoxing"
          className={classNames(
            'text-[12px] rotate-[180deg]',
            isLogin ? 'text-[#ffffff]' : 'text-[#111111]',
          )}
        />
      )}
    </span>
  );
};

export default SelectLang;
